import { render, staticRenderFns } from "./DdMenu.vue?vue&type=template&id=5a43dfdb&scoped=true&"
import script from "./DdMenu.vue?vue&type=script&lang=js&"
export * from "./DdMenu.vue?vue&type=script&lang=js&"
import style0 from "./DdMenu.vue?vue&type=style&index=0&id=5a43dfdb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43dfdb",
  null
  
)

export default component.exports